import Contact from "./contact";
import Payment from "./payment";
import OrderItem from "./orderItem";
import { Type } from "class-transformer";
import { observable } from "mobx";
import { EntityValidationRules } from "../services/validationService";

export enum OrderStatus {
  Open = "OPEN",
  PaidBankTransfer = "PAID_BANK_TRANSFER",
  Paid = "PAID",
  Deferred = "DEFERRED",
  Failed = "FAILED",
}

export default class Order {
  @Type(() => Contact)
  @observable
  contact: Contact = new Contact();

  @Type(() => Payment)
  @observable
  payment: Payment = new Payment();

  @observable
  proposedPurchaseRequestId?: string;

  @observable
  status: OrderStatus = OrderStatus.Open;

  id: string;

  @Type(() => Date)
  expires: Date;

  @Type(() => OrderItem)
  @observable
  orderItems: OrderItem[] = [new OrderItem()];

  _createdAt: Date = new Date();

  @observable
  _termsAgreement = false;

  _origin: "single" | "multiple" = "single";

  @observable
  _wasReopen = false;
}

export const OrderValidationRules: EntityValidationRules<Order> = {
  _termsAgreement: {
    isTrue: true,
  },
};
